import styled from 'styled-components'

const Container = styled.div`
  width: 40px;
  height: 40px;
  background-color: #e27837;
  color: #fff;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
`

const Indicator = ({ number }) => {
  return <Container>{number}</Container>
}

export default Indicator
